import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { useEffect, useState } from "react";
import { AppBox, AppContainer, AppModal } from "../../../commons/components";
import { setPageTitle } from "../../../redux/slices/page-title-slice";
import IconEdit from "../../../commons/components/icons/edit";
import { cleanUpStepperFormData } from "../../../redux/slices/stepper-form-slice";
import ProfileEdit from "./component/profileEdit/ProfileEdit";
import { authUserProfile } from "../../../redux/slices/profile-slice";
import { setUser } from "../../../redux/slices/session-slice";
import { User } from "../../../commons/models/user";
import ProfileManageDetailHeader from "./component/ProfileManageDetailHeader";
import ProfileInfo from "./component/ProfileInfo";
import { appSession } from "../../../commons";

export default function ProfileDetailManage() {
  const dispatch = useAppDispatch();
  const [isEditProfile, setIsEditProfile] = useState(false);
  const { stepperFormModalSize } = useAppSelector((state) => state.screenResize);
  const { user } = useAppSelector((state) => state.session);

  useEffect(() => {
    dispatch(setPageTitle("Profile"));
  }, []);

  useEffect(() => {
    // If no user in Redux, try restoring from localStorage
    if (!user?.id) {
      const storedUser = appSession.getUser() as User;
      if (storedUser) {
        try {
          dispatch(setUser(storedUser));
        } catch {
          console.warn("Invalid authUser data in localStorage.");
        }
      }
    }
  }, [user]);

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedUser = appSession.getUser() as User;
      if (updatedUser) {
        dispatch(setUser(updatedUser as User));
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleAfterEdit = () => {
    setIsEditProfile(false);
    dispatch(authUserProfile())
      .unwrap()
      .then((res) => {
        const updatedUser = new User().create(res) as User;
        appSession.setUser(updatedUser);
        dispatch(setUser(updatedUser));
      });
  };

  const handleAfterEditClose = () => {
    setIsEditProfile(false);
    dispatch(cleanUpStepperFormData());
  };

  return (
    <AppContainer>
      <AppBox mt="md" flexDirection="column" gap="md">
        <ProfileManageDetailHeader user={user!} onEditProfile={() => setIsEditProfile(true)} />
        <ProfileInfo user={user!} />
      </AppBox>
      {user && (
        <AppModal
          opened={isEditProfile}
          modalSize={stepperFormModalSize}
          onClose={handleAfterEditClose}
          title="Edit Profile"
          titleIcon={<IconEdit />}
          withoutButtons
        >
          <ProfileEdit userData={user} onSave={handleAfterEdit} />
        </AppModal>
      )}
    </AppContainer>
  );
}
